import axios from 'axios';
import { APIS } from './Config';

const ApiService = {
    test: function (url) {
        let _token = localStorage.getItem('tokenukc');
        return axios({
            method: 'GET',
            url: `${url}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            }
        });
    },

    validaDNI: function (dni) {
        let _token = localStorage.getItem('tokenukc');
        return axios({
            method: 'GET',
            url: `${APIS.valida_dni}/${dni}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            }
        });
    },

    crmValidate: function (data) {
        let _token = localStorage.getItem('tokenukc');
        return axios({
            method: 'POST',
            url: `${APIS.crm_validate}`,
            data,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            }
        });
    },

    // APIS
    getData: function (url) {
        let _token = localStorage.getItem('tokenukc');
        return axios({
            method: 'GET',
            url: `${url}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            }
        });
    },

    getDataFile: function (url) {
        let _token = localStorage.getItem('tokenukc');
        return axios({
            method: 'GET',
            url: `${url}`,
            headers: {
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            },
            responseType: 'arraybuffer'
        });
    },

    getUrlPagoEnLinea: function (data) {

        return axios({
            method: 'POST',
            url: process.env.REACT_APP_MAGICLINK_PAGOENLINEA,
            data
        });
    },

    deleteData: function (url) {
        let _token = localStorage.getItem('tokenukc');
        return axios({
            method: 'DELETE',
            url: `${url}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            }
        });
    },

    postData: function (url, data) {
        let _token = localStorage.getItem('tokenukc');
        return axios({
            method: 'POST',
            url: `${url}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            },
            data
        });
    },

    postDataFormData: function (url, data) {
        let _token = localStorage.getItem('tokenukc');
        return axios({
            method: 'POST',
            url: `${url}`,
            headers: {
                "Content-Type": "multipart/form-data",
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            },
            data
        });
    },

    postDataLinkedin: function (url, data, headers) {
        let _token = localStorage.getItem('tokenukc');
        headers['Authorization'] = `Bearer ${_token}`;
        headers['user-role'] = `sales_manager`;
        headers['user-id'] = ``;
        return axios({
            method: 'POST',
            url: `${url}`,
            headers: headers,
            data
        });
    },

    postKcLogin: function () {
        let params = new URLSearchParams();
        params.append('client_id', APIS.kcLoginData.client_id);
        params.append('username', APIS.kcLoginData.username);
        params.append('password', APIS.kcLoginData.password);
        params.append('grant_type', APIS.kcLoginData.grant_type);
        params.append('scope', APIS.kcLoginData.scope);

        let config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
            }
        }

        return axios.post(`${APIS.kcLogin}`, params, config);
    },

    getKcUserProfile: function (_token) {
        return axios({
            method: 'GET',
            url: `${APIS.kcUserProfile}`,
            headers: {
                'Authorization': `Bearer ${_token}`,
                'user-role': process.env.REACT_APP_KEYCLOAK_USER_ROLE,
                'user-id': ''
            }
        });
    },

    checkProgramType: function (type) {
        let data = null;
        switch (type) {
            case 'MAES':
                data = { id: '', code: '', idc: null, type: 2, form: 1, show: false, color: 'blue', label: 'Maestría', data: [] };
                break;
            case 'SEG':
                data = { id: '', code: '', idc: null, type: 2, form: 3, show: false, color: 'blue', label: 'Segunda Especialidad', data: [] };
                break;
            case 'DOCT':
                data = { id: '', code: '', idc: null, type: 2, form: 1, show: false, color: 'blue', label: 'Doctorado', data: [] };
                break;
            case 'PDC':
                data = { id: '', code: '', idc: null, type: 1, form: 1, show: false, color: 'blue', label: 'Doctorado', data: [] };
                break;
            case 'LABS':
                data = { id: '', code: '', idc: null, type: 3, form: 2, show: false, color: 'blue', label: 'Programa de Especialización', data: [] };
                break;
            case 'LAB':
                data = { id: '', code: '', idc: null, type: 3, form: 2, show: false, color: 'blue', label: 'Programa de Especialización', data: [] };
                break;
            case 'PDE':
                data = { id: '', code: '', idc: null, type: 3, form: 2, show: false, color: 'blue', label: 'Programa de Especialización', data: [] };
                break;
            case 'CEX':
                data = { id: '', code: '', idc: null, type: 3, form: 2, show: false, color: 'blue', label: 'Programa de Especialización', data: [] };
                break;
            case 'CDE':
                data = { id: '', code: '', idc: null, type: 4, form: 2, show: false, color: 'blue', label: 'Curso de Especialización', data: [] };
                break;
            default:
                data = { id: '', code: '', idc: null, type: 4, form: 2, show: false, color: 'blue', label: 'No especificado', data: [] };
                break
        }

        return data;
    }
}

export default ApiService;